import type { Expediente } from '../expedientes/cliente-expedientes.js'
import { ErrorApi } from '../identidad/cliente-identidad.js'
import { notificar } from '../fundacion/alertas.js'
import { crearCorrespondenciaPropia, listarCorrespondencia } from './cliente-correspondencia.js'
const elemento = <T extends Element>(selector: string): T => {
  const dato = document.querySelector<T>(selector)
  if (!dato) throw new Error(`No existe ${selector}`)
  return dato
}
let expediente: Expediente | null = null
function aviso(texto: string, tipo = 'success') {
  const alerta = elemento<HTMLElement>('#alerta-correspondencia')
  alerta.className = 'alert d-none'
  notificar(texto, tipo === 'danger' ? 'error' : (tipo as 'success' | 'warning' | 'info'))
}
export async function mostrarCorrespondencia(nuevo: Expediente, roles: string[]): Promise<void> {
  expediente = nuevo
  elemento('#panel-correspondencia').classList.remove('d-none')
  const lista = await listarCorrespondencia()
  const contenedor = elemento<HTMLElement>('#lista-correspondencia')
  contenedor.replaceChildren(
    ...lista.datos.map((dato) => {
      const fila = document.createElement('div')
      fila.className = 'border-bottom py-2'
      fila.textContent = `${dato.fecha} — ${dato.titulo} (${dato.clase})`
      return fila
    }),
  )
  elemento('#formulario-correspondencia').classList.toggle(
    'd-none',
    !(roles.includes('ESTUDIANTE') && nuevo.estado === 'ABIERTO'),
  )
  elemento('#panel-correspondencia').scrollIntoView({ behavior: 'smooth', block: 'start' })
}
elemento<HTMLFormElement>('#formulario-correspondencia').addEventListener('submit', (evento) => {
  evento.preventDefault()
  if (!expediente) return
  const formulario = evento.currentTarget as HTMLFormElement
  const archivo = (formulario.elements.namedItem('archivo') as HTMLInputElement).files?.[0]
  if (!archivo) return
  const datos: Record<string, string> = {}
  for (const campo of ['titulo', 'descripcion', 'tipoDocumento', 'visibilidad'])
    datos[campo] = (formulario.elements.namedItem(campo) as HTMLInputElement).value
  void crearCorrespondenciaPropia(expediente.id, datos, archivo)
    .then(() => mostrarCorrespondencia(expediente!, ['ESTUDIANTE']))
    .then(() => aviso('Correspondencia almacenada.'))
    .catch((error: unknown) =>
      aviso(
        error instanceof ErrorApi ? error.message : 'No fue posible almacenar el documento.',
        'danger',
      ),
    )
})
